import { DateTime, Interval } from 'luxon';
import { TimeAssessmentFilterEnum } from '@whizz/api-model';
import { FIRST_ASSESSMENT_DATE, LAST_ASSESSMENT_DATE } from './constants';
import { BUDDHIST_YEARS } from './vars';

export const TODAY = new Date();

//TODO: Check if this is necessary as Lesson History Table just does a toLocaleString without adding years
export const getDateStringWithLocale = (date: Date, locale: string | undefined): string => {
  const dateObj = DateTime.fromJSDate(date).setLocale(locale ?? 'en-gb');
  if (locale === 'th-th') {
    dateObj.plus({ years: BUDDHIST_YEARS });
  }
  return dateObj.toLocaleString();
};

export const dateTimeToDateString = (dateTime: unknown): unknown | string => {
  if (DateTime.isDateTime(dateTime)) {
    return dateTime.toFormat('y-LL-dd');
  }

  return dateTime;
};

export const toISOFromSCFormat = (date: string): string => {
  return DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss').toISO();
};

export const generateDateTime = (date: string | DateTime | null): DateTime => {
  if (null === date) {
    return DateTime.now();
  }

  if (DateTime.isDateTime(date)) {
    return date;
  }

  if (TimeAssessmentFilterEnum.FIRST_ASSESSMENT === date) {
    return DateTime.fromISO(FIRST_ASSESSMENT_DATE);
  }

  if (TimeAssessmentFilterEnum.LAST_ASSESSMENT === date) {
    return DateTime.fromISO(LAST_ASSESSMENT_DATE);
  }

  return DateTime.fromISO(date);
};

export const getDiffWeeks = (startDate: string | DateTime, endDate: string | DateTime | null): number => {
  const weeks = Interval
    .fromDateTimes(generateDateTime(startDate), generateDateTime(endDate))
    .length('weeks');

  return Math.floor(weeks);
};
